const IconTag = props => {
	return (
		<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.5988 1.31543H8.46543C7.99876 1.31543 7.5321 1.51543 7.19876 1.84876L1.86543 7.1821C1.1321 7.91543 1.1321 9.04876 1.86543 9.7821L6.66543 14.5821C7.39876 15.3154 8.5321 15.3154 9.26543 14.5821L14.5988 9.24876C14.9321 8.91543 15.1321 8.44876 15.1321 7.9821V1.84876C15.1321 1.5821 14.9321 1.31543 14.5988 1.31543ZM11.9321 5.7821C11.1988 5.7821 10.5988 5.1821 10.5988 4.44876C10.5988 3.71543 11.1988 3.11543 11.9321 3.11543C12.6654 3.11543 13.2654 3.71543 13.2654 4.44876C13.2654 5.1821 12.6654 5.7821 11.9321 5.7821Z"
				fill="currentColor"
			/>
		</svg>
	);
};
export default IconTag;
